import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarBadgesService {
  public myBadgeSubject = new BehaviorSubject<number>(0);
  constructor() { }
}
